<div class="add-tire-storage-modal" id="add-tire-storage-modal-id">
  <div class="template-header mb-0">
    <div class="ui-g-12 flex-between-center py-0">
      <div class="flex-start-center width-100p">
        <i class="far fa-inventory header-icon"></i>
        <div class="template-description width-100p p-relative">
          <div class="modal-heading" style="padding-left: 2px !important;">
            Tire storage
          </div>
        </div>
        <i id="template-close-dialog" class="far fa-times pointer dialog-close fz-20" (click)="closeDialog()"></i>
      </div>
    </div>
  </div>

  <div class="template-header mb-0">
    <div class="ui-g-3 flex-between-center py-0">
      <div class="flex-start-center width-100p">
        <i class="far fa-user header-icon fz-16"></i>
        <div class="template-description width-100p p-relative border-right ">
          <div class="modal-heading">
            {{customer?.displayName}}
          </div>
        </div>
      </div>
    </div>

    <div class="ui-g-9 flex-between-center p-0">
      <div class="flex-start-center width-100p">
        <i class="far fa-car header-icon fz-16"></i>
        <div class="template-description width-100p p-relative">
          <div class="modal-heading">
            {{vehicle?.name}}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="ui-g-12 add-tire-storage-modal-body">
    <div class="body-scroll">
      <div class="flex-between-center">
        <div class="option-heading">Current Storage</div>

        <div class="flex-end-center p-right-6">

          <button class="btn flex-start-center height-33 mr-2" [disabled]="!isTireSelected || isSwappingTire"
            [ngClass]="{ 'btn-primary': isTireSelected, 'btn-white btn-border': !isTireSelected }"
            (click)="handleSwapTire()">
            <i class="far fa-sync font-14 pr-2"></i>
            <span [ngClass]="{'pr-2': isSwappingTire}">Swap tires</span>
            <i *ngIf="isSwappingTire" class="fal fa-spinner rotate"></i>
          </button>

          <button class="btn flex-start-center height-33 mr-2" [disabled]="!isTireSelected || isRemovingTire"
            [ngClass]="{ 'btn-primary': isTireSelected, 'btn-white btn-border': !isTireSelected  }"
            (click)="handleRemoveTire()">
            <i class="far fa-undo font-14 pr-2"></i>
            <span [ngClass]="{'pr-2': isRemovingTire}">Return tires</span>
            <i *ngIf="isRemovingTire" class="fal fa-spinner rotate"></i>
          </button>

          <button class="btn btn-primary btn-submit flex-start-center height-33" [disabled]="isAddingTire"
            (click)="handleAddingTire()">
            <i class="far fa-plus font-14 pr-2"></i>
            <span [ngClass]="{'pr-2': isAddingTire}">Add tires</span>
            <i *ngIf="isAddingTire" class="fal fa-spinner rotate"></i>
          </button>

        </div>
      </div>

      <div class="ui-g-12 pl-0">
        <div class="add-tire-storage-list ui-g-12 p-0">
          <p-table #dt [columns]="cols" [value]="currentStorage" [scrollable]="true" [lazy]="true" [responsive]="true"
            [paginator]="false" [rows]="currentStorage?.length" [totalRecords]="totalRecords">
            <ng-template pTemplate="header" let-columns>
              <tr class="add-tire-grid-row-header">
                <th *ngFor="let col of columns" [ngClass]="col.class">
                  <span class="position-relative">
                    <span>{{col.title}}</span>
                  </span>
                </th>
              </tr>
            </ng-template>

            <!-- Table Body -->
            <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex" let-columns="columns">
              <tr class="add-tire-storage-grid-row" *ngIf="!isLoading">
                <td *ngFor="let col of columns" [ngClass]="col.class">
                  <span *ngIf="col.field === 'storageLocation'" class="m-neg-left-6">
                    <app-checkbox inputId="cb-sms-template-{{col.field}}"
                      [isChecked]="getSelectedTireStorage(rowData?.tireStorageId)" [checkState]="0"
                      (appChange)="onSelectTire(rowData?.tireStorageId, $event)">
                    </app-checkbox>
                    <span>
                      {{ rowData[col.field]}}
                    </span>
                  </span>

                  <span *ngIf="col.field === 'storageRO'" class="hover-underline pointer"
                    (click)="openEstimate(rowData?.storageROId)">
                    {{ rowData[col.field]}}
                  </span>

                  <span *ngIf="col.field === 'removalRO'" class="hover-underline pointer"
                    (click)="openEstimate(rowData?.removalROId)">
                    {{ rowData[col.field]}}
                  </span>

                  <span *ngIf="col.field === 'externalId'" class="hover-underline pointer"
                    (click)="openTireStorageDialog(rowData?.tireStorageId)">
                    {{ rowData[col.field]}}
                  </span>

                  <span
                    *ngIf="col.field !== 'storageLocation' && col.field !== 'externalId' && col.field !== 'storageRO' && col.field !== 'removalRO'">
                    {{ rowData[col.field]}}
                  </span>

                </td>
              </tr>
            </ng-template>
          </p-table>

          <div *ngIf="!isLoading && currentStorage?.length === 0"
            class="ui-g-12 mv-10 border-gray-85 text-center not-found empty-table-height">
            <span class="font-gray-35 font-13 mt-2">No tires in storage currently</span>
          </div>

          <div *ngIf="isLoading"
            class="ui-g-12 mv-10 border-gray-85 text-center not-found no-data-vector empty-table-height">
            Loading...
          </div>
        </div>
      </div>

      <div class="ui-g-12 option-heading">
        Past Storage
      </div>

      <!-- Past storage table -->
      <div class="ui-g-12 pl-0">
        <div class="add-tire-storage-list ui-g-12 p-0">
          <p-table #dt [columns]="cols" [value]="pastStorage" [scrollable]="true" [lazy]="true" [responsive]="true"
            [paginator]="false" [rows]="pastStorage?.length" [totalRecords]="totalRecords">

            <ng-template pTemplate="header" let-columns>
              <tr class="add-tire-grid-row-header">
                <th *ngFor="let col of columns" [ngClass]="col.class">
                  <span class="position-relative" [ngClass]="{'m-neg-left-22': col.title === 'Location'}">
                    <span>{{col.title}}</span>
                  </span>
                </th>
              </tr>
            </ng-template>

            <!-- Table Body -->
            <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex" let-columns="columns">
              <tr class="add-tire-storage-grid-row disable-color" *ngIf="!isLoading">
                <td *ngFor="let col of columns" [ngClass]="col.class">
                  <span *ngIf="col.field === 'storageLocation'" class="m-neg-left-6">
                    <span>
                      {{ rowData[col.field]}}
                    </span>
                  </span>
                  <span *ngIf="col.field === 'storageRO'" class="hover-underline pointer"
                    (click)="openEstimate(rowData?.storageROId)">
                    {{ rowData[col.field]}}
                  </span>

                  <span *ngIf="col.field === 'removalRO'" class="hover-underline pointer"
                    (click)="openEstimate(rowData?.removalROId)">
                    {{ rowData[col.field]}}
                  </span>

                  <span *ngIf="col.field === 'externalId'" class="hover-underline pointer"
                    (click)="openTireStorageDialog(rowData?.tireStorageId)">
                    {{ rowData[col.field]}}
                  </span>

                  <span
                    *ngIf="col.field !== 'storageLocation' && col.field !== 'externalId' && col.field !== 'storageRO' && col.field !== 'removalRO'">
                    {{ rowData[col.field]}}
                  </span>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <div *ngIf="!isLoading && pastStorage?.length === 0"
            class="ui-g-12 mv-10 border-gray-85 text-center not-found  empty-table-height">
            <span class="font-gray-35 font-13 mt-2">No tires storage history for the vehicle</span>
          </div>

          <div *ngIf="isLoading"
            class="ui-g-12 mv-10 border-gray-85 text-center not-found no-data-vector empty-table-height">
            Loading...
          </div>
        </div>
      </div>
    </div>
  </div>
</div>